<template>
  <div id="index" ref="appRef">
    <div class="bg login_box">
      <div class="login_content">
        <h1>融AI大数据可视化平台</h1>
        <el-form
          class="login-form"
          :model="loginForm"
          :rules="rules"
          ref="numberForm"
          label-width="0px"
          @submit.native.prevent
        >
          <el-form-item prop="loginName">
            <el-input
              autocomplete="off"
              auto-complete="off"
              placeholder="登录名/手机号"
              prefix-icon="el-icon-user-solid"
              v-model="loginForm.loginName"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              autocomplete="off"
              auto-complete="off"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              v-model="loginForm.password"
            ></el-input>
          </el-form-item>

          <el-form-item prop="code">
            <div class="input-wrapper">
              <el-input placeholder="请输入验证码" v-model="loginForm.code">
                <i slot="prefix">
                  <img src="@/assets/vercode.png" alt="" />
                </i>
              </el-input>
              <img @click="getCaptcha()" class="img" :src="captchaimg" alt="" />
            </div>
          </el-form-item>

          <div class="loginbtn">
            <el-button
              @click="onSubmit"
              type="primary"
              native-type="submit"
              class="submit-btn"
              >立即登录
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import { getSession, getCaptcha, publicKeyAPI } from '@/api/login/login';
import { Message } from 'element-ui';
import { fullScreen } from '@/utils/index';
import JSEncrypt from 'jsencrypt';
// import { v4 as uuidv4 } from 'uuid';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      loginForm: {
        loginName: '',
        password: '',
        code: ''
      },
      publicKey: '',
      key: '',
      rules: {
        loginName: [{ required: true, message: '请输入' }],
        password: [{ required: true, message: '请输入密码' }],
        code: [{ required: true, message: '请输入验证码' }]
      },
      captchaimg: ''
    };
  },
  mounted() {
    this.getPublicKey();
    this.getCaptcha();
  },
  methods: {
    async onSubmit() {
      /**
       * 调用登录接口
       * 成功：
       *     保存token
       *     跳转到首页，并给出成功的提示
       * 失败：给出错误提示，让用户重新登录
       */
      this.$refs['numberForm'].validate((valid) => {
        if (valid) {
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(
            '-----BEGIN PUBLIC KEY-----\n' +
              this.publicKey +
              '\n' +
              '-----END PUBLIC KEY-----'
          );
          const password = encrypt.encrypt(this.loginForm.password);
          const params = {
            ...this.loginForm,
            password,
            uuid: this.key
          };

          getSession(params).then((response) => {
            if (response.code === '0') {
              // 成功
              Message.success('登录成功');
              // 设置token
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('userId', response.data.userId);
              localStorage.setItem('userName', response.data.userName);
              // 跳转
              this.$router.push({ name: 'home' });
              // 全屏
              fullScreen();
            } else {
              Message.error(response.message);
              console.error(response);
            }
          });
        } else {
          return false;
        }
      });
    },

    async getPublicKey() {
      try {
        const res = await publicKeyAPI();
        this.publicKey = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取图形验证码
    async getCaptcha() {
      this.key = uuid.v1().replace(/-/g, '');
      await getCaptcha({ uuid: this.key, captchaType: 'png' })
        .then((res) => {
          this.displayImage(res);
        })
        .catch((res) => {});
    },
    displayImage(blob) {
      const imageUrl = URL.createObjectURL(blob);
      this.captchaimg = imageUrl;
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';

.login_box {
  width: 100%;
  height: 100%;
  //background-color: #324057;
  position: relative;

  .login_content {
    width: 640px;
    // height: 350px;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    position: absolute;
    top: 30%;
    left: 30%;
    padding-top: 2%;

    h1 {
      text-align: center;
      width: 100%;
      height: 40px;
      line-height: 40px;
    }

    .login-form {
      padding: 30px;
      box-sizing: border-box;
      .loginbtn {
        margin-top: 40px;
        width: 100%;
        text-align: center;

        .submit-btn {
          width: 357px;
          height: 58px;
          background: #128bf1;
          border-radius: 8px;
          font-size: 24px;
          border: transparent;
        }
      }
    }
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .el-input {
      width: 70%;
    }
  }
}
</style>
